/* tslint:disable */
/* eslint-disable */
/* @relayHash 84b10c13ebafa3e202537480b5e519f2 */

import { ConcreteRequest } from "relay-runtime";
export type zipCodeLookupQueryVariables = {
    zipCode: string;
    country: string;
};
export type zipCodeLookupQueryResponse = {
    readonly viewer: {
        readonly zipCode: ReadonlyArray<{
            readonly city: string | null;
            readonly state: string | null;
            readonly country: string | null;
        } | null> | null;
    };
};
export type zipCodeLookupQuery = {
    readonly response: zipCodeLookupQueryResponse;
    readonly variables: zipCodeLookupQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "country"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zipCode"
},
v2 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "zipCode"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "zipCodeLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "zipCode",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "zipCodeLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "zipCode",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/306.0.0-2021-03-15T23:43:35.521Z/zipCodeLookupQuery",
    "metadata": {},
    "name": "zipCodeLookupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'e8c10a44b9376bcc81c18823387740fc';
export default node;
